import moment from "moment";
// const formatPrice = (price) => {
//   const priceInNumber = Number(price);
//   if (price >= 1) {
//     return Number(priceInNumber.toFixed(2));
//   } else if (price < 1 && price !== 0) {
//     const count = -Math.floor(Math.log10(Number(price)) + 1);
//     if (count === Infinity) {
//       return Number(price);
//     } else {
//       console.log(Number(priceInNumber.toFixed(4 + count)))
//       return Number(priceInNumber.toFixed(4 + count));
//     }
//   } else {
//     console.log(Number(price))
//     return Number(price);
//   }
// };
const formatPrice = (price) => {
  const priceInNumber = Math.abs(Number(price));
  if (price >= 1) {
    return Number(priceInNumber.toFixed(2));
  } else if (price <= -1) {
    return -Number(priceInNumber.toFixed(2));
  } else if (price > 0 && price < 1) {
    let count = -Math.floor(Math.log10(priceInNumber) + 1);
    if (count === Infinity) {
      return Number(price);
    } else {
      return Number(priceInNumber.toFixed(4 + count));
    }
  } else if (price < 0 && price > -1) {
    let count = -Math.floor(Math.log10(priceInNumber + 1));
    if (count === Infinity) {
      return Number(price);
    } else {
      return -Number(priceInNumber.toFixed(4 + count));
    }
  } else {
    return Number(price);
  }
};
const formatNumber = (cap) => {
  const capInNumber = Number(cap);
  if (capInNumber > 1.0e12) {
    return `${(capInNumber / 1.0e12).toFixed(0)}T`;
  }
  if (capInNumber < 1.0e12 && capInNumber > 1.0e9) {
    return `${(capInNumber / 1.0e9).toFixed(0)}B`;
  }
  if (capInNumber < 1.0e9 && capInNumber > 1.0e6) {
    return `${(capInNumber / 1.0e6).toFixed(0)}M`;
  }
};

const compareProgress = (a, b) => {
  const c = Number(a);
  const d = Number(b);

  let value = (c / (c + d)) * 100;
  value = value < 0.1 ? 0.1 : value;

  return `${value}px`;
};
const formatName = (name) => {
  let formattedName;
  var re = /[._-\w]/;
  if (name) {
    if (name.split(" ")[0].length < 11) {
      return `${formattedName.substring(0, 1).toUpperCase()}${formattedName
        .substring(1, formattedName.length)
        .toLowerCase()}`;
    } else if (name.split(re)[0].length < 11) {
    }
    formattedName =
      name.split(re)[0] > 11 ? name.substring(0, 11) : name.split(re)[0];

    // name.split(" ")[0].length > 11
    //   ? name.split(re)[0] > 11
    //     ? name.split(re)[0].substring(0, 10)
    //     : name.split(re)[0]
    //   : name.substring(0, 11);
  } else {
    return null;
  }
};
const MaximumWidth = (a, b) => {
  const c = Number(a);
  const d = Number(b);
  let count = 1;
  if (c < d) {
    let value = (c / d) * 100;
    if (value < 10 && value > 1) {
      count *= 10;
    }
    if (value < 1) {
      let decimal = -Math.floor(Math.log10(c / d) + 1);
      count = count * 100 * Math.pow(10, decimal);
    }
  } else if (c > d) {
    let value = (d / c) * 100;
    if (value < 10 && value > 1) {
      count *= 10;
    }
    if (value < 1) {
      let decimal = -Math.floor(Math.log10(d / c) + 1);
      count = count * 100 * Math.pow(10, decimal);
    }
  }
  let e = count * 100;
  let f = (c / d) * count * 100;

  const greatest = e > f ? e : f;
  return `${greatest + 50}px`;
};
const formatDate = (p, prev, interval) => {
  if (interval === "7d") {
    prev = interval;
  }
  let d =
    p === 1
      ? moment().format()
      : prev === "ytd"
      ? "2021-01-01T22:44:41"
      : prev === "All"
      ? "2008-04-14T22:44:41"
      : prev === "6m"
      ? moment().subtract(6, "months").format()
      : prev === "1m"
      ? moment().subtract(1, "months").format()
      : prev === "7d"
      ? moment().subtract(7, "days").format()
      : prev === "1d"
      ? moment().subtract(1, "days").format()
      : "";

  return `${d.split("+")[0]}Z`;
};
const formatDateInRFC = (d) => {
  function pad(n) {
    return n < 10 ? "0" + n : n;
  }
  return (
    d.getUTCFullYear() +
    "-" +
    pad(d.getUTCMonth() + 1) +
    "-" +
    pad(d.getUTCDate()) +
    "T" +
    pad(d.getUTCHours()) +
    ":" +
    pad(d.getUTCMinutes()) +
    ":" +
    pad(d.getUTCSeconds()) +
    "Z"
  );
};

const formatNumberNormally = (d, c = 2) => {
  let a = Number(d);

  return Number(a.toFixed(c));
};

export {
  formatPrice,
  formatNumber,
  compareProgress,
  MaximumWidth,
  formatName,
  formatDate,
  formatDateInRFC,
  formatNumberNormally,
};
